<template>
    <b-row>
        <b-col>
            <div class="stepper-wrapper">
                <div :class="step.status===1 ? `stepper-item completed`: step.status===2? `stepper-item error`: 'stepper-item'"  v-for="(step,index) in steps" :key="index">
                    <div class="step-counter"><i v-if="step.status===1" class="ri-check-fill"></i> <span v-else>{{index+1}}</span></div>
                    <div class="step-name">{{step.title}}</div>
                </div>
            </div>
        </b-col>
    </b-row>
</template>
<script>
export default {
    props: ['status', 'is_resubmitted', 'hospital_app', 'flag', 'hospital_approve_status'],
    data () {
        return {
            steps: []
        }
    },
    computed: {
        currentLocale () {
            return this.$i18n.locale
        }
    },
    watch: {
        currentLocale: function (newVal, oldVal) {
            this.stepChange()
        }
    },
    created () {
        this.stepChange()
    },
    methods: {
        stepChange () {
            let steps
            if (this.is_resubmitted === 1) {
                if (this.hospital_app === 1) {
                    if (this.flag === 0) {
                        steps = [
                            { status: 1, title: window.vm.$t('globalTrans.pendingAlternative') },
                            { status: 0, title: window.vm.$t('globalTrans.processing') },
                            { status: 0, title: window.vm.$t('globalTrans.approved') }
                        ]
                    } else if (this.flag === 99 && this.hospital_approve_status === 0) {
                        steps = [
                            { status: 1, title: window.vm.$t('globalTrans.pendingAlternative') },
                            { status: 1, title: window.vm.$t('globalTrans.processing') },
                            { status: 0, title: window.vm.$t('globalTrans.approved') }
                        ]
                    } else if (this.flag === 99 && this.hospital_approve_status === 1) {
                        steps = [
                            { status: 1, title: window.vm.$t('globalTrans.pendingAlternative') },
                            { status: 1, title: window.vm.$t('globalTrans.processing') },
                            { status: 1, title: window.vm.$t('globalTrans.approved') }
                        ]
                    }
                } else if (this.status === 1) {
                    steps = [
                        { status: 1, title: window.vm.$t('globalTrans.pendingAlternative') },
                        { status: 0, title: window.vm.$t('globalTrans.processing') },
                        { status: 0, title: window.vm.$t('globalTrans.review') },
                        { status: 0, title: window.vm.$t('globalTrans.approved') },
                        { status: 0, title: window.vm.$t('globalTrans.disbursed') }
                    ]
                } else if (this.status === 2) {
                    steps = [
                        { status: 1, title: window.vm.$t('globalTrans.pendingAlternative') },
                        { status: 1, title: window.vm.$t('globalTrans.processing') },
                        { status: 0, title: window.vm.$t('globalTrans.review') },
                        { status: 0, title: window.vm.$t('globalTrans.approved') },
                        { status: 0, title: window.vm.$t('globalTrans.disbursed') }
                    ]
                } else if (this.status === 3) {
                    steps = [
                        { status: 1, title: window.vm.$t('globalTrans.pendingAlternative') },
                        { status: 1, title: window.vm.$t('globalTrans.processing') },
                        { status: 1, title: window.vm.$t('globalTrans.review') },
                        { status: 0, title: window.vm.$t('globalTrans.approved') },
                        { status: 0, title: window.vm.$t('globalTrans.disbursed') }
                    ]
                } else if (this.status === 4) {
                    steps = [
                        { status: 1, title: window.vm.$t('globalTrans.pendingAlternative') },
                        { status: 1, title: window.vm.$t('globalTrans.processing') },
                        { status: 1, title: window.vm.$t('globalTrans.review') },
                        { status: 1, title: window.vm.$t('globalTrans.approved') },
                        { status: 0, title: window.vm.$t('globalTrans.disbursed') }
                    ]
                } else if (this.status === 5) {
                    steps = [
                        { status: 1, title: window.vm.$t('globalTrans.pendingAlternative') },
                        { status: 1, title: window.vm.$t('globalTrans.processing') },
                        { status: 1, title: window.vm.$t('globalTrans.review') },
                        { status: 1, title: window.vm.$t('globalTrans.approved') },
                        { status: 1, title: window.vm.$t('globalTrans.disbursed') }
                    ]
                } else if (this.status === 6) {
                    steps = [
                        { status: 1, title: window.vm.$t('globalTrans.pendingAlternative') },
                        { status: 1, title: window.vm.$t('globalTrans.processing') },
                        { status: 1, title: window.vm.$t('globalTrans.rejected') }
                    ]
                }
            } else {
                if (this.hospital_app === 1) {
                    if (this.flag === 0) {
                        steps = [
                            { status: 1, title: window.vm.$t('globalTrans.pendingAlternative') },
                            { status: 0, title: window.vm.$t('globalTrans.processing') },
                            { status: 0, title: window.vm.$t('globalTrans.approved') }
                        ]
                    } else if (this.flag === 99 && this.hospital_approve_status === 0) {
                        steps = [
                            { status: 1, title: window.vm.$t('globalTrans.pendingAlternative') },
                            { status: 1, title: window.vm.$t('globalTrans.processing') },
                            { status: 0, title: window.vm.$t('globalTrans.approved') }
                        ]
                    } else if (this.flag === 99 && this.hospital_approve_status === 1) {
                        steps = [
                            { status: 1, title: window.vm.$t('globalTrans.pendingAlternative') },
                            { status: 1, title: window.vm.$t('globalTrans.processing') },
                            { status: 1, title: window.vm.$t('globalTrans.approved') }
                        ]
                    }
                } else if (this.status === 1) {
                    steps = [
                        { status: 1, title: window.vm.$t('globalTrans.pendingAlternative') },
                        { status: 0, title: window.vm.$t('globalTrans.processing') },
                        { status: 0, title: window.vm.$t('globalTrans.approved') },
                        { status: 0, title: window.vm.$t('globalTrans.disbursed') }
                    ]
                } else if (this.status === 2) {
                    steps = [
                        { status: 1, title: window.vm.$t('globalTrans.pendingAlternative') },
                        { status: 1, title: window.vm.$t('globalTrans.processing') },
                        { status: 0, title: window.vm.$t('globalTrans.approved') },
                        { status: 0, title: window.vm.$t('globalTrans.disbursed') }
                    ]
                } else if (this.status === 3) {
                    steps = [
                        { status: 1, title: window.vm.$t('globalTrans.pendingAlternative') },
                        { status: 1, title: window.vm.$t('globalTrans.processing') },
                        { status: 1, title: window.vm.$t('globalTrans.review') },
                        { status: 0, title: window.vm.$t('globalTrans.approved') },
                        { status: 0, title: window.vm.$t('globalTrans.disbursed') }
                    ]
                } else if (this.status === 4) {
                    steps = [
                        { status: 1, title: window.vm.$t('globalTrans.pendingAlternative') },
                        { status: 1, title: window.vm.$t('globalTrans.processing') },
                        { status: 1, title: window.vm.$t('globalTrans.approved') },
                        { status: 0, title: window.vm.$t('globalTrans.disbursed') }
                    ]
                } else if (this.status === 5) {
                    steps = [
                        { status: 1, title: window.vm.$t('globalTrans.pendingAlternative') },
                        { status: 1, title: window.vm.$t('globalTrans.processing') },
                        { status: 1, title: window.vm.$t('globalTrans.approved') },
                        { status: 1, title: window.vm.$t('globalTrans.disbursed') }
                    ]
                } else if (this.status === 6) {
                    steps = [
                        { status: 1, title: window.vm.$t('globalTrans.pendingAlternative') },
                        { status: 1, title: window.vm.$t('globalTrans.processing') },
                        { status: 1, title: window.vm.$t('globalTrans.rejected') }
                    ]
                }
            }
            this.steps = steps
        }
    }
}
</script>
<style scoped>
.stepper-wrapper {
    margin-top: auto;
    display: flex;
    justify-content: space-between;
    margin-bottom: 20px;
}
.stepper-item {
    position: relative;
    display: flex;
    flex-direction: column;
    align-items: center;
    flex: 1;

@media (max-width: 768px) {
    font-size: 12px;
}
}

.stepper-item::before {
    position: absolute;
    content: "";
    border-bottom: 2px solid #ccc;
    width: 100%;
    top: 20px;
    left: -50%;
    z-index: 2;
}

.stepper-item::after {
    position: absolute;
    content: "";
    border-bottom: 2px solid #ccc;
    width: 100%;
    top: 20px;
    left: 50%;
    z-index: 2;
}

.stepper-item .step-counter {
    position: relative;
    z-index: 5;
    display: flex;
    justify-content: center;
    align-items: center;
    width: 40px;
    height: 40px;
    border-radius: 50%;
    background: #ccc;
    margin-bottom: 6px;
    color: white;
}

.stepper-item.active {
    font-weight: bold;
}

.stepper-item.completed .step-counter {
    background-color: #4bb543;
    color:white;
}
.stepper-item.error .step-counter {
    background-color: #dc3545;
    color: white;
}

.stepper-item.completed::after {
    position: absolute;
    content: "";
    border-bottom: 2px solid #4bb543;
    width: 100%;
    top: 20px;
    left: 50%;
    z-index: 3;
}

.stepper-item:first-child::before {
    content: none;
}
.stepper-item:last-child::after {
    content: none;
}
.step-name {
    color: black;
    font-weight: bold;
    font-size: 11px;
}
</style>
